import OidcLoginInfoDTO from 'models/dto/oidcLoginInfoDTO';
import { OidcIssuerInfo } from 'models/identityProvider';

export function mapFromOidcLoginInfo(dto: OidcLoginInfoDTO): OidcIssuerInfo {
  return {
    issuer: dto.issuer,
    clientId: dto.client_id,
    displayName: dto.display_name ?? dto.issuer,
    authorizationEndpoint: dto.authorization_endpoint,
    jwksUri: dto.jwks_uri,
    endSessionEndpoint: dto.end_session_endpoint ?? undefined,
    userInfoEndpoint: dto.userinfo_endpoint ?? undefined,
    offlineAccessSupported: dto.offline_access_supported === true,
  };
}
